module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base-module/components/dialog-box/dialog-box.component.html
// module id = ./src/app/modules/base-module/components/dialog-box/dialog-box.component.html
// module chunks = 9